/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Delete_TitleInputs */

const en_admin_permissions_delete_title = /** @type {(inputs: Admin_Permissions_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Permission`)
};

const zh_admin_permissions_delete_title = /** @type {(inputs: Admin_Permissions_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除权限`)
};

/**
* | output |
* | --- |
* | "Delete Permission" |
*
* @param {Admin_Permissions_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_delete_title = /** @type {((inputs?: Admin_Permissions_Delete_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Delete_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_delete_title(inputs)
	return zh_admin_permissions_delete_title(inputs)
});
export { admin_permissions_delete_title as "admin.permissions.delete_title" }